<template>
  <div>
    <input-field
      label="Playback Authorization Endpoint"
      label-position="top"
    >
      <b-form-input
        v-model="value.playbackAuthorizationEndpoint"
        placeholder="Enter playback authorization endpoint..."
      />
    </input-field>

    <b-row class="justify-content-center my-1">
      <b-col cols="6">
        <input-field
          label="Allow list"
          label-position="top"
        >
          <div class="w-100 position-relative">
            <v-select
              v-model="allowedCountries"
              multiple
              placeholder="Select countries here..."
              label="name"
              class="distro-single-select"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="countries"
            />
            <div
              v-if="fetchingCountries"
              class="position-absolute loading position-top-0 position-left-0 position-right-0 position-bottom-0"
            >
              <b-spinner small />
            </div>
          </div>
        </input-field>
      </b-col>

      <b-col cols="6">
        <input-field
          label="Disallow list"
          label-position="top"
        >
          <div class="w-100 position-relative">
            <v-select
              v-model="disallowedCountries"
              multiple
              placeholder="Select countries here..."
              label="name"
              class="distro-single-select"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="countries"
            />
            <div
              v-if="fetchingCountries"
              class="position-absolute loading position-top-0 position-left-0 position-right-0 position-bottom-0"
            >
              <b-spinner small />
            </div>
          </div>
        </input-field>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import vSelect from 'vue-select'

export default {
  name: 'EncoderAuthorizationSettings',
  components: { vSelect },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      allowedCountries: [],
      disallowedCountries: [],
    }
  },
  computed: {
    countries() {
      return this.$store.state.organization.countries || []
    },
    fetchingCountries() {
      return this.$store.state.organization.fetchingCountries
    },
  },
  watch: {
    allowedCountries(val) {
      this.value.allowedCountries = val.map(e => e.code)
    },
    disallowedCountries(val) {
      this.value.disallowedCountries = val.map(e => e.code)
    },
    countries() {
      this.updateLists()
    },
  },
  created() {
    if (this.countries.length) this.updateLists()
  },
  methods: {
    updateLists() {
      if (this.value.allowedCountries) this.allowedCountries = this.value.allowedCountries.map(e => this.countries.find(el => e === el.code))
      if (this.value.disallowedCountries) this.disallowedCountries = this.value.disallowedCountries.map(e => this.countries.find(el => e === el.code))
    },
  },
}
</script>
